import React from 'react'
import { useLocation, useOutletContext, useParams } from 'react-router-dom';
import DashboardHeader from '../components/Other/DashboardHeader';
import PageHeaderTitle from '../components/pages/PageHeaderTitle';
import PerformanceSection from '../components/Other/PerformanceSection';

const PerformancePage = () => {
  const [sidebarToggle] = useOutletContext();
    const location = useLocation();
  const user_name = location.state?.user_name;
  // Forwarded from the Record card's sparkline click so the empty state shows
  // the right copy (no-trades vs building, private vs public) on this page too.
  const hasTraded = location.state?.hasTraded;
  const isSelf = location.state?.isSelf;


  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      {/* Desktop: no big title / grey line — the house-rule heading is rendered
          inside PerformanceSection so it aligns with the chart content. */}
      <PageHeaderTitle
        title={user_name ? `${user_name}'s Performance` : "Performance"}
        showDesktopTitle={false}
      />
      <PerformanceSection
        hasTraded={hasTraded}
        isSelfProfile={isSelf}
        pageTitle={user_name ? `${user_name}'s Performance` : "Performance"}
      />
    </>
  );
}


export default PerformancePage
